// extracted by mini-css-extract-plugin
module.exports = {"background":"background_video-module--background--19qWa","video":"background_video-module--video--2L5Iz"};